import { initializeApp } from 'firebase/app';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getDatabase } from 'firebase/database';
import { getAnalytics } from 'firebase/analytics';


const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDTUl9Rj9KIxcFzRLQe7D6-dE3wnn-e9Og",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "last-printer-9e168.firebaseapp.com",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://last-printer-9e168-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "last-printer-9e168",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "last-printer-9e168.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "986965485983",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:986965485983:web:020b1ab0660eca911075aa",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-4ZYDT2YRFP"
};

const app = initializeApp(firebaseConfig);
console.log('🔥 Firebase initialized with config:', {
  projectId: firebaseConfig.projectId,
  databaseURL: firebaseConfig.databaseURL,
  authDomain: firebaseConfig.authDomain,
  usingEnvVars: {
    apiKey: !!process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: !!process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: !!process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: !!process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: !!process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: !!process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: !!process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: !!process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
  }
});

const storage = getStorage(app);

if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATOR === 'true') {
  try {
    connectStorageEmulator(storage, 'localhost', 9199);
  } catch (error) {
    console.log('Storage emulator already initialized or not available:', error.message);
  }
}

const database = getDatabase(app);
console.log('📊 Firebase Database initialized');
console.log('🔗 Database URL:', app.options.databaseURL);

const analytics = getAnalytics(app);
console.log('📈 Firebase Analytics initialized');

export { storage, database, app, analytics };



